module.exports = __webpack_public_path__ + "static/colouring_in_bernard-b44b09f12113b5eb9bd410264ba43398.pdf";